import React from 'react'
import Styled from 'styled-components'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(fab)

const Menu = () => (
    <MenuWrapper>
        <ul>
            <li><a href="https://designrevision.com">Store</a></li>
            <li><a href="https://designrevision.com/blog">Blog</a></li>
            <li><a href="https://designrevision.com/my-account">My Account</a></li>
        </ul>

        <ul className="social">
            <li><a href="https://twitter.com/designrevision"><FontAwesomeIcon icon={['fab', 'twitter']} /></a></li>
            <li><a href="https://www.facebook.com/designrevision"><FontAwesomeIcon icon={['fab', 'facebook']} /></a></li>
            <li><a href="https://github.com/designrevision/shards-react"><FontAwesomeIcon icon={['fab', 'github']} /></a></li>
        </ul>
    </MenuWrapper>
)

export default Menu

const MenuWrapper = Styled.div`
    margin-left: auto;
    margin-right: 15px;
    position: relative;
    top: 2px;

    ul, li {
        margin: 0;
        padding: 0;
        display: inline-block;
    }

    ul {
        margin-right: 10px;

        li {
            margin: 0 .45rem;
            font-size: 14px;

            a {
                color: #515f6b;
                text-decoration: none;
                position: relative;

                &:after {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 50%;
                    bottom: -15px;
                    margin-left: -7px;
                    width: 14px;
                    height: 1px;
                    background: #2d53fe;
                    opacity: 0;
                    transition: all .17s ease-in-out;
                }

                &:hover {
                    color: #2d53fe;

                    &:after {
                        opacity: 1;
                        bottom: -10px;
                    }
                }
            }
        }

        &.social a:after { display: none; }
    }

    @media (max-width: 780px) {
        display: none;
    }
`
